/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {EmailsImportResult} from './EmailsImportResult';
import {FileType} from './FileType';

/**
 * The EmailsImport model module.
 * @module model/EmailsImport
 * @version 1.0.0
 */
export class EmailsImport {
  /**
   * Constructs a new <code>EmailsImport</code>.
   * @alias module:model/EmailsImport
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsImport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsImport} obj Optional instance to populate.
   * @return {module:model/EmailsImport} The populated <code>EmailsImport</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsImport();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('file'))
        obj.file = FileType.constructFromObject(data['file']);
      if (data.hasOwnProperty('fieldsMap'))
        obj.fieldsMap = ApiClient.convertToType(data['fieldsMap'], 'String');
      if (data.hasOwnProperty('state'))
        obj.state = ApiClient.convertToType(data['state'], 'String');
      if (data.hasOwnProperty('result'))
        obj.result = EmailsImportResult.constructFromObject(data['result']);
      if (data.hasOwnProperty('startDate'))
        obj.startDate = ApiClient.convertToType(data['startDate'], 'String');
      if (data.hasOwnProperty('endDate'))
        obj.endDate = ApiClient.convertToType(data['endDate'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
EmailsImport.prototype._id = undefined;

/**
 * @member {String} title
 */
EmailsImport.prototype.title = undefined;

/**
 * @member {module:model/FileType} file
 */
EmailsImport.prototype.file = undefined;

/**
 * @member {String} fieldsMap
 */
EmailsImport.prototype.fieldsMap = undefined;

/**
 * Allowed values for the <code>state</code> property.
 * @enum {String}
 * @readonly
 */
EmailsImport.StateEnum = {
  /**
   * value: "pending"
   * @const
   */
  pending: "pending",

  /**
   * value: "importing"
   * @const
   */
  importing: "importing",

  /**
   * value: "done"
   * @const
   */
  done: "done"
};
/**
 * @member {module:model/EmailsImport.StateEnum} state
 */
EmailsImport.prototype.state = undefined;

/**
 * @member {module:model/EmailsImportResult} result
 */
EmailsImport.prototype.result = undefined;

/**
 * @member {String} startDate
 */
EmailsImport.prototype.startDate = undefined;

/**
 * @member {String} endDate
 */
EmailsImport.prototype.endDate = undefined;

/**
 * @member {String} created
 */
EmailsImport.prototype.created = undefined;

/**
 * @member {String} updated
 */
EmailsImport.prototype.updated = undefined;

